export default __webpack_public_path__ + "static/animation-img5-68cbd6d10f8ee264739efeb2fb458177.webp";